<div class="window"
     [ngClass]="isMaximized? 'maximized':  'minimized'"
     [class.closed]="isClosed"
>
  @if (isClosed) {
    <div>
      <button class="control-btn" mat-icon-button (click)="onOpen()">
        <mat-icon> arrow_back_ios</mat-icon>
      </button>
    </div>
  } @else {
    <div class="window-header">
      @if (process().showLoading && !process().processFinished) {
        <mat-spinner class="spinner"></mat-spinner>
      }
      <span class="window-title">
        @if (process().process) {
          {{ process().process }}
        } @else {
          Server Message
        }
      </span>
      <div class="window-controls">

        @if (isMaximized) {
          <button class="control-btn" mat-icon-button (click)="onMinimize()">
            <mat-icon>minimize</mat-icon>
          </button>
        } @else {
          @if (errorMessages() && errorMessages()!.length > 0) {
            <mat-icon class="error-btn">report</mat-icon>
          }
          <button class="control-btn" mat-icon-button (click)="onMaximize()">
            <mat-icon>open_in_full</mat-icon>
          </button>
        }
        <button class="control-btn" mat-icon-button (click)="onClose()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    @if (!isMaximized) {
      @if (process().showProcess) {
        <div class="progress">
          <mat-progress-bar class="progress-bar"
                            [class.finished]="process().processFinished"
                            mode="determinate"
                            [value]="process().percentage"></mat-progress-bar>
        </div>
      }
    } @else {
      <div class="window-body">

        <div class="body-wrapper">
          <div class="body-wrapper--content">
            <ng-content></ng-content>
          </div>
          @if (errorMessages() && errorMessages()!.length > 0) {
            <div class="window-errors">
              @for (errorMessage of errorMessages(); track $index) {
                <div class="error-item">
                  <div class="error-message">{{ errorMessage }}</div>
                  <button class="remove-button" (click)="removeError($index)" aria-label="Remove error">
                    &times;
                  </button>
                </div>
              }
            </div>
          }
        </div>
        @if (process().showProcess) {
          <div class="progress">
            <mat-progress-bar class="progress-bar" mode="determinate"
                              [class.finished]="process().processFinished"
                              [value]="process().percentage"></mat-progress-bar>
            <span>{{ process().processedPapers }}/{{ process().totalPapers }}</span>
          </div>
        }
      </div>
    }

  }
</div>
